import { render, staticRenderFns } from "./TemplateFeed.vue?vue&type=template&id=1d4c68c4"
import script from "./TemplateFeed.vue?vue&type=script&lang=js"
export * from "./TemplateFeed.vue?vue&type=script&lang=js"
import style0 from "./TemplateFeed.vue?vue&type=style&index=0&id=1d4c68c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports